import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { useHistory } from 'react-router-dom'
import { useWeightLossSetupEnabled } from '@/redux/selectors'
import Template from '../Template'
import { checkoutRoutes } from '../routes'
import getPreScreeningSteps from '@/programmes/WeightLoss/steps/getPreScreeningSteps'
import Form from '@/programmes/components/FormV2'
import messages from '../messages'
import useIsUnder18Check from '@/programmes/WeightLoss/hooks/useIsUnder18Check'
import Spinner from '@/programmes/components/Spinner'
import ExitView from '@/programmes/components/Form/components/ExitView'
import { Step } from '@/programmes/components/FormV2/types'

const SetupQuestionnairePage = () => {
  const t = useFormatMessage()
  const history = useHistory()
  const weightLossSetupEnabled = useWeightLossSetupEnabled()
  const { loading: under18CheckLoading, under18 } = useIsUnder18Check()
  const preScreeningSteps = getPreScreeningSteps() as Step[]

  return (
    <Template title={t(messages.setupQuestionnairePageTitle)}>
      {weightLossSetupEnabled && (
        <>
          {under18CheckLoading && <Spinner colour="#000000" />}

          {!under18 && !under18CheckLoading && (
            <Form
              steps={preScreeningSteps}
              onSubmit={() => history.push(checkoutRoutes.home)}
            />
          )}

          {under18 && !under18CheckLoading && <ExitView />}
        </>
      )}
    </Template>
  )
}

export default SetupQuestionnairePage
